export default __webpack_public_path__ + "static/JMC-logo-footer-2fc4d58069205d6f8eb233844f5737d8.svg";